import http from "@/libs/config/http";
export async function getProducts(params) {
  try {
    const response = await http(`products/list?${params ?? ""}`);
    return response;
  } catch (error) {
    console.error("getProducts error:", error);
    return null;
  }
}
